var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgBonanzaCoinGolden = function SvgBonanzaCoinGolden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 120"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st1 {\n        fill: url(#radial-gradient);\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -168.6,
    cy: -1.2,
    fx: -168.6,
    fy: -1.2,
    r: 1,
    gradientTransform: "translate(-19964.2 -20239.1) rotate(-135) scale(169.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffdc5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffedac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd12c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,120c33.1,0,60-26.9,60-60S93.1,0,60,0,0,26.9,0,60s26.9,60,60,60Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5,96.3c-3.8,0-7.7-.5-11.6-1.4s-7.2-2.2-9.8-3.7l.6-14.5h3l3.2,7.2c1,2,2,3.7,3,5,1,1.3,2.4,2.3,4.2,3,1.2.5,2.3.8,3.4,1,1.1.2,2.3.3,3.6.3,4.2,0,7.6-1.1,10-3.3,2.5-2.2,3.7-5.1,3.7-8.7s-.8-5.8-2.5-7.7-4.4-3.7-8.2-5.4l-4.3-1.9c-5.8-2.6-10.4-5.5-13.8-8.9-3.4-3.4-5-7.9-5-13.5s1.1-7.7,3.2-10.7c2.1-2.9,5-5.2,8.8-6.8,3.7-1.6,8.1-2.4,13.1-2.4s7.1.5,10.3,1.5,6,2.3,8.5,3.9l-.7,12.9h-3l-3.8-7.8c-1.1-2.3-2.2-3.9-3.2-4.9-1-1-2.2-1.6-3.7-1.9-.8-.1-1.5-.2-2.1-.3-.6,0-1.4-.1-2.3-.1-3.4,0-6.3,1-8.8,3-2.5,2-3.7,4.7-3.7,8.2s.9,6,2.8,8.1,4.6,3.9,8.1,5.5l4.7,2c6.7,2.9,11.5,6,14.5,9.3,2.9,3.3,4.4,7.5,4.4,12.6s-2.3,11-6.9,14.8c-4.6,3.8-11.1,5.7-19.5,5.7h0Z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgBonanzaCoinGolden);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/bonanza-coin-golden.fb9e799d82d5695f56de8063ee63f5c2.svg";